<script lang="ts">
  import Markdown from '../Markdown.svelte';
  const vegaExample = `
{
  "$schema": "https://vega.github.io/schema/vega/v5.json",
  "description": "A basic bar chart example, with value labels shown upon mouse hover.",
  "width": 400,
  "height": 200,
  "padding": 5,

  "data": [
    {
      "name": "table",
      "values": [
        {"category": "A", "amount": 28},
        {"category": "B", "amount": 55},
        {"category": "C", "amount": 43},
        {"category": "D", "amount": 91},
        {"category": "E", "amount": 81},
        {"category": "F", "amount": 53},
        {"category": "G", "amount": 19},
        {"category": "H", "amount": 87}
      ]
    }
  ],

  "signals": [
    {
      "name": "tooltip",
      "value": {},
      "on": [
        {"events": "rect:mouseover", "update": "datum"},
        {"events": "rect:mouseout",  "update": "{}"}
      ]
    }
  ],

  "scales": [
    {
      "name": "xscale",
      "type": "band",
      "domain": {"data": "table", "field": "category"},
      "range": "width",
      "padding": 0.05,
      "round": true
    },
    {
      "name": "yscale",
      "domain": {"data": "table", "field": "amount"},
      "nice": true,
      "range": "height"
    }
  ],

  "axes": [
    { "orient": "bottom", "scale": "xscale" },
    { "orient": "left", "scale": "yscale" }
  ],

  "marks": [
    {
      "type": "rect",
      "from": {"data":"table"},
      "encode": {
        "enter": {
          "x": {"scale": "xscale", "field": "category"},
          "width": {"scale": "xscale", "band": 1},
          "y": {"scale": "yscale", "field": "amount"},
          "y2": {"scale": "yscale", "value": 0}
        },
        "update": {
          "fill": {"value": "steelblue"}
        },
        "hover": {
          "fill": {"value": "red"}
        }
      }
    },
    {
      "type": "text",
      "encode": {
        "enter": {
          "align": {"value": "center"},
          "baseline": {"value": "bottom"},
          "fill": {"value": "#333"}
        },
        "update": {
          "x": {"scale": "xscale", "signal": "tooltip.category", "band": 0.5},
          "y": {"scale": "yscale", "signal": "tooltip.amount", "offset": -2},
          "text": {"signal": "tooltip.amount"},
          "fillOpacity": [
            {"test": "datum === tooltip", "value": 0},
            {"value": 1}
          ]
        }
      }
    }
  ]
}`;
  const vegaLiteExample = `
{
  "$schema": "https://vega.github.io/schema/vega-lite/v5.json",
  "description": "A simple bar chart with embedded data.",
  "data": {
    "values": [
      {"a": "A", "b": 28}, {"a": "B", "b": 55}, {"a": "C", "b": 43},
      {"a": "D", "b": 91}, {"a": "E", "b": 81}, {"a": "F", "b": 53},
      {"a": "G", "b": 19}, {"a": "H", "b": 87}, {"a": "I", "b": 52}
    ]
  },
  "mark": "bar",
  "encoding": {
    "x": {"field": "a", "type": "nominal", "axis": {"labelAngle": 0}},
    "y": {"field": "b", "type": "quantitative"}
  }
}    
`;
  const traceryExample = `
{
	"sentence": ["The #color# #animal# of the #natureNoun# is called #name#"],
	"color": ["orange","blue","white","black","grey","purple","indigo","turquoise"],
	"animal": ["unicorn","raven","sparrow","scorpion","coyote","eagle","owl","lizard","zebra","duck","kitten"],
	"natureNoun": ["ocean","mountain","forest","cloud","river","tree","sky","sea","desert"],
	"name": ["Arjun","Yuuma","Darcy","Mia","Chiaki","Izzi","Azra","Lina"]
}
`;
  const mongoExample = `
[
   {
      $match:
      {"date": { $gte: new ISODate( "2020-01-30" ), $lt: new ISODate( "2022-01-30" ) }}
   },
   {
      $group:
      {
         _id: { $dateToString: { format: "%Y-%m-%d", date: "$date" } },
         totalOrderValue: { $sum: { $multiply: [ "$price", "$quantity" ] } },
         averageOrderQuantity: { $avg: "$quantity" }
      }
   },
   {$sort: { totalOrderValue: -1 }}
 ]
`;
  const exampleMap = {
    Vega: vegaExample,
    'Vega-Lite': vegaLiteExample,
    Tracery: traceryExample,
    MongoDB: mongoExample
  };
  let seletedLang: keyof typeof exampleMap = 'Vega-Lite';
  $: currentExample = exampleMap[seletedLang];
  $: text = '```\n' + currentExample + '\n```';
  const langs: (keyof typeof exampleMap)[] = ['Vega-Lite', 'Vega', 'Tracery', 'MongoDB'];
</script>

<div class="flex flex-col justify-center">
  <Markdown text={'## Language Examples'} />
  <div class="flex justify-between my-2 ">
    {#each langs as lang}
      <button
        class="border-b-2 cursor-pointer font-bold dark:border-slate-400"
        class:border-black={seletedLang === lang}
        class:dark:border-white={seletedLang === lang}
        on:click|preventDefault={() => {
          seletedLang = lang;
        }}
      >
        <Markdown text={lang} />
      </button>
    {/each}
  </div>
  <div class="max-h-96 overflow-y-auto">
    <Markdown {text} />
  </div>
</div>
